import {Injectable} from '@angular/core';
import {Burly} from 'kb-burly';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {GlobalNotification} from '../models/global-notification.model';
import {GlobalNotificationResponse} from '../responses/global-notifications.response';

@Injectable({
  providedIn: 'root'
})
export class TorchGlobalNotificationsService {

  interval$ = timer(1, 900000);

  allNotifications$ =  new BehaviorSubject<GlobalNotification[]>([])

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
    this.interval$.pipe(switchMap(_ => this.getAllNotificationEntries())).subscribe(notifications => {
      this.allNotifications$.next(notifications);
    })
  }

  /**
   * Retrieve all global notifications
   * @param onlyActive - Set to true to get only active notifications (defaults: true)
   */
  getAllNotificationEntries(onlyActive = true): Observable<GlobalNotification[]> {
    let endpointURL = Burly(this.config.rootUrl)
      .addSegment('/global-notifications');


    if (onlyActive === true) {
      endpointURL = endpointURL.addQuery('filter', `isActive||$eq||true`);
    }

    return this.httpClient.get<GlobalNotificationResponse>(endpointURL.get).pipe(
      map(response => response.data)
    );
  }

  /**
   * Create a global notification
   * @param notification
   */
  createNotification(notification: GlobalNotification) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/global-notifications')
      .get;

    return this.httpClient.post<GlobalNotification>(endpointURL, notification);
  }

  /**
   * Get notification types
   */
  getNotificationTypes(): Observable<string[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/global-notifications')
      .addSegment('/types')
      .get;

    return this.httpClient.get<string[]>(endpointURL);
  }

  /**
   * Update a global notification
   * @param notification
   */
  updateNotification(notification: GlobalNotification) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/global-notifications')
      .addSegment(`/${notification.id}`)
      .get;

    return this.httpClient.patch<GlobalNotification>(endpointURL, notification);
  }

  /**
   * Delete a global notification
   * @param notification
   */
  deleteNotification(notification: GlobalNotification) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/global-notifications')
      .addSegment(`/${notification.id}`)
      .get;

    return this.httpClient.delete<GlobalNotification>(endpointURL);
  }

  /**
   * Force update the notifications observable
   */
  forceUpdate() {
    this.getAllNotificationEntries().subscribe(notifications => {
      this.allNotifications$.next(notifications);
    })
  }
}
